import type { CardAssetRecomendationData } from '.';
import type { Dispatch, FC, SetStateAction } from 'react';
import { MoreVertical } from '@eqi-investimentos/icons/web';
import { Box, Flex, Text } from '@eqi-investimentos/react';
import { Tag, TagLabel } from '@chakra-ui/react';
import { Thumb } from '@/components/atoms/Thumb';
import { mapRecommendationStatus } from './utils';
import { IfRender } from '@/utils/jsx';
export const FrontFace: FC<FrontFaceProps> = ({
  data: {
    name,
    recommendation,
    thumb,
    ticker,
    subcategory
  },
  setIsShowingFront
}) => {
  return <Box pos="relative" w="13.25rem" h="9.375rem" p="1rem" borderRadius="0.5rem" bgColor="background.alwaysDark" cursor="pointer" onClick={() => setIsShowingFront(() => false)} data-sentry-element="Box" data-sentry-component="FrontFace" data-sentry-source-file="FrontFace.tsx">
      <Flex pos="relative" justifyContent="flex-end" px="2.5" pt="0.3125rem" pb="1" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
        <MoreVertical width={24} height={24} fill="action.active.brandLight" style={{
        transform: 'rotate(90deg)'
      }} data-sentry-element="MoreVertical" data-sentry-source-file="FrontFace.tsx" />
      </Flex>
      <Flex flexDir="column" px="4" gap="m" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
        <Flex alignItems="center" gap="m" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
          <Flex alignItems="center" justifyContent="center" minW="3.125rem" maxW="3.125rem" minH="3.125rem" maxH="3.125rem" bgColor="content.alwaysLight" borderRadius="md" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
            <Thumb src={thumb} width={40} height={40} fit="cover" radius={5} alt={name} data-sentry-element="Thumb" data-sentry-source-file="FrontFace.tsx" />
          </Flex>
          <Flex flexDir="column" gap="0.5" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
            <Text className="container__cad_recommendation_label_name" maxW="7.5rem" fontSize="1rem" fontWeight="normal" lineHeight="5" color="content.alwaysLight" noOfLines={1} data-sentry-element="Text" data-sentry-source-file="FrontFace.tsx">
              {name}
            </Text>
            <Text fontSize="m" fontWeight="normal" lineHeight="md" color="content.alwaysLight" data-sentry-element="Text" data-sentry-source-file="FrontFace.tsx">
              {ticker}
            </Text>
          </Flex>
        </Flex>
        <Flex alignItems="center" gap="xs" data-sentry-element="Flex" data-sentry-source-file="FrontFace.tsx">
          <IfRender condition={!!subcategory} data-sentry-element="IfRender" data-sentry-source-file="FrontFace.tsx">
            <Tag px="0.3125rem" minW="2.375rem" minH="5" maxH="5" color="content.alwaysDark" bgColor="content.alwaysLight" borderRadius="0.125rem" data-sentry-element="Tag" data-sentry-source-file="FrontFace.tsx">
              <TagLabel fontSize="s" fontWeight="bold" lineHeight="5" data-sentry-element="TagLabel" data-sentry-source-file="FrontFace.tsx">
                {subcategory}
              </TagLabel>
            </Tag>
          </IfRender>
          <Tag px="0.3125rem" minW="2.375rem" minH="5" maxH="5" color={mapRecommendationStatus[recommendation].color} bgColor={mapRecommendationStatus[recommendation].bg} borderRadius="0.125rem" data-sentry-element="Tag" data-sentry-source-file="FrontFace.tsx">
            <TagLabel fontSize="s" fontWeight="bold" lineHeight="5" data-sentry-element="TagLabel" data-sentry-source-file="FrontFace.tsx">
              {mapRecommendationStatus[recommendation].label}
            </TagLabel>
          </Tag>
        </Flex>
      </Flex>
    </Box>;
};
type FrontFaceProps = {
  data: CardAssetRecomendationData;
  setIsShowingFront: Dispatch<SetStateAction<boolean>>;
};